import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const AdminModule = lazy(loadModule);

export default AdminModule;
